/* Twyrl. theme: menu, product gallery, variant pricing, AJAX basket drawer, sticky add-to-basket. */
(function () {
  "use strict";
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const SYMBOL = document.documentElement.dataset.currencySymbol || "£";
  const money = (cents) => SYMBOL + (Number(cents) / 100).toFixed(2);

  /* ---------- toast ---------- */
  const toastEl = document.querySelector("[data-toast]");
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toastEl.hidden = true), 3200);
  }

  /* ---------- basket drawer ---------- */
  const Cart = {
    el: document.querySelector("[data-cart-drawer]"),
    scrim: document.querySelector("[data-cart-scrim]"),
    open() {
      if (!this.el) { window.location.href = ROOT + "cart"; return; }
      this.el.hidden = false;
      this.scrim.hidden = false;
      document.body.style.overflow = "hidden";
      const c = this.el.querySelector("[data-cart-close]");
      if (c) c.focus();
    },
    close() {
      if (!this.el) return;
      this.el.hidden = true;
      this.scrim.hidden = true;
      document.body.style.overflow = "";
    },
    async refresh() {
      const res = await fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } });
      const cart = await res.json();
      this.render(cart);
      return cart;
    },
    async change(key, quantity) {
      const res = await fetch(ROOT + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message || "Could not update your basket");
      this.render(cart);
    },
    render(cart) {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (!this.el) return;
      const lines = this.el.querySelector("[data-cart-lines]");
      const ship = this.el.querySelector("[data-cart-ship]");
      const sub = this.el.querySelector("[data-cart-subtotal]");
      const checkout = this.el.querySelector("[data-cart-checkout]");
      sub.textContent = money(cart.total_price);
      checkout.hidden = cart.item_count === 0;
      const d = this.el.dataset;
      ship.textContent = "";
      if (cart.item_count) {
        const b = document.createElement("b");
        b.textContent = d.msgShipFull || "";
        const bar = document.createElement("div");
        bar.className = "bar";
        bar.innerHTML = '<i style="width:100%"></i>';
        ship.append(b, bar);
      } else {
        ship.textContent = d.msgShipEmpty || "";
      }
      lines.textContent = "";
      if (!cart.item_count) {
        const empty = document.createElement("div");
        empty.className = "empty";
        empty.textContent = d.msgEmpty || "";
        lines.appendChild(empty);
        return;
      }
      cart.items.forEach((item) => {
        const row = document.createElement("div");
        row.className = "line";
        const img = document.createElement("img");
        img.alt = "";
        if (item.image) img.src = item.image + (item.image.includes("?") ? "&" : "?") + "width=160";
        const info = document.createElement("div");
        const name = document.createElement("div");
        name.className = "n";
        name.textContent = item.product_title;
        info.appendChild(name);
        if (item.variant_title && !item.product_has_only_default_variant) {
          const v = document.createElement("div");
          v.className = "s";
          v.textContent = item.variant_title;
          info.appendChild(v);
        }
        const q = document.createElement("div");
        q.className = "q";
        q.innerHTML =
          '<button type="button" aria-label="Decrease quantity">−</button><span></span><button type="button" aria-label="Increase quantity">+</button>';
        q.querySelector("span").textContent = item.quantity;
        const [minus, plus] = q.querySelectorAll("button");
        minus.addEventListener("click", () => this.change(item.key, item.quantity - 1).catch((e) => toast(e.message)));
        plus.addEventListener("click", () => this.change(item.key, item.quantity + 1).catch((e) => toast(e.message)));
        info.appendChild(q);
        const rm = document.createElement("button");
        rm.type = "button";
        rm.className = "rm";
        rm.textContent = "Remove";
        rm.addEventListener("click", () => this.change(item.key, 0).catch((e) => toast(e.message)));
        info.appendChild(rm);
        const price = document.createElement("b");
        price.textContent = money(item.final_line_price);
        row.append(img, info, price);
        lines.appendChild(row);
      });
    },
  };
  window.TwyrlCart = Cart;

  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-cart-open]");
    if (opener && Cart.el) { e.preventDefault(); Cart.open(); }
    if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-scrim]")) Cart.close();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") Cart.close(); });

  /* ---------- mobile menu ---------- */
  function initMenu(scope) {
    const btn = scope.querySelector("[data-menu-toggle]");
    const nav = scope.querySelector("[data-mobile-nav]");
    if (!btn || !nav) return;
    btn.addEventListener("click", () => {
      nav.hidden = !nav.hidden;
      btn.setAttribute("aria-expanded", String(!nav.hidden));
    });
    nav.addEventListener("click", (e) => { if (e.target.closest("a")) nav.hidden = true; });
  }

  /* ---------- product: gallery, variants, add to basket ---------- */
  function initProduct(root) {
    const main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-thumb]").forEach((b) => {
      b.addEventListener("click", () => {
        if (!main) return;
        main.removeAttribute("srcset");
        main.src = b.dataset.src;
        main.alt = b.dataset.alt || "";
        root.querySelectorAll("[data-thumb]").forEach((x) => x.setAttribute("aria-pressed", "false"));
        b.setAttribute("aria-pressed", "true");
      });
    });

    const form = root.querySelector("form[data-product-form]");
    if (!form) return;
    const now = root.querySelector("[data-price-now]");
    const was = root.querySelector("[data-price-was]");
    const tag = root.querySelector("[data-price-tag]");
    const stickyPrice = root.querySelector("[data-sticky-price]");
    const qty = form.querySelector("[name=quantity]");
    const add = form.querySelector("[data-add]");

    function selected() {
      return form.querySelector("input[name=id]:checked") || form.querySelector("[name=id]");
    }
    function update() {
      const r = selected();
      if (!r) return;
      const p = Number(r.dataset.price);
      const c = Number(r.dataset.compare || 0);
      if (now) now.textContent = money(p);
      const onSale = c > p;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(c); }
      if (tag) { tag.hidden = !onSale; if (onSale) tag.textContent = (tag.dataset.format || "[percent]% off").replace("[percent]", Math.round(((c - p) * 100) / c)); }
      if (stickyPrice) stickyPrice.innerHTML = money(p) + (onSale ? " <s>" + money(c) + "</s>" : "");
      const available = r.dataset.available !== "false";
      add.disabled = !available;
      add.textContent = available ? add.dataset.label : add.dataset.soldout;
    }
    form.addEventListener("change", (e) => { if (e.target.name === "id") update(); });
    root.querySelectorAll("[data-qty]").forEach((b) =>
      b.addEventListener("click", () => {
        qty.value = Math.max(1, Math.min(10, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qty)));
      })
    );
    update();

    form.addEventListener("submit", async (e) => {
      if (!Cart.el) return; // no drawer: let the normal form post run
      e.preventDefault();
      add.disabled = true;
      try {
        const res = await fetch(ROOT + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Could not add to basket");
        await Cart.refresh();
        Cart.open();
      } catch (err) {
        toast(err.message);
      } finally {
        update();
      }
    });

    const sticky = root.querySelector("[data-sticky]");
    const stickyAdd = root.querySelector("[data-sticky-add]");
    if (stickyAdd) stickyAdd.addEventListener("click", () => (form.requestSubmit ? form.requestSubmit() : form.submit()));
    if (sticky && "IntersectionObserver" in window) {
      new IntersectionObserver((entries) =>
        entries.forEach((en) => sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0))
      ).observe(add);
    }
  }

  /* ---------- basket activity line: fade in + count up ---------- */
  function initSocialProof(scope) {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    scope.querySelectorAll("[data-sp-anim]").forEach((el) => {
      if (reduce || !("IntersectionObserver" in window) || el.dataset.spReady) return;
      el.dataset.spReady = "1";
      const num = el.querySelector("[data-sp-count]");
      const target = num ? parseInt(num.dataset.spCount, 10) || 0 : 0;
      el.classList.add("is-anim");
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          requestAnimationFrame(() => el.classList.add("is-in"));
          if (!num || !target) return;
          const start = performance.now(), dur = 1100;
          const tick = (now) => {
            const p = Math.min(1, (now - start) / dur);
            num.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(tick);
          };
          num.textContent = "0";
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* ---------- review cards: arrows for the swipe track ---------- */
  function initReviews(scope) {
    scope.querySelectorAll("[data-rv]").forEach((wrap) => {
      const track = wrap.querySelector("[data-rv-track]");
      const prev = wrap.querySelector("[data-rv-prev]");
      const next = wrap.querySelector("[data-rv-next]");
      if (!track || !prev || !next || wrap.dataset.rvReady) return;
      wrap.dataset.rvReady = "1";
      const step = () => {
        const card = track.querySelector(".rv-card");
        return card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
      track.addEventListener("scroll", update, { passive: true });
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") { e.preventDefault(); next.click(); }
        if (e.key === "ArrowLeft") { e.preventDefault(); prev.click(); }
      });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- spinning curler head (3D) ---------- */
  // Builds a cylinder from vertical slices of the head image. Each slice shows exactly the part of
  // the photo it covers when seen from the front, so at rest it looks identical to the photo.
  function buildCylinder(cyl) {
    if (cyl.dataset.built) return;
    const src = cyl.dataset.src;
    const N = 24;                              // slices per half turn
    const d = Math.PI / N;
    const half = Math.sin(d / 2);              // slice width as a fraction of the head width
    const apothem = 50 * Math.cos(d / 2);      // distance from axis, in cqw (head width = 100cqw)
    const frag = document.createDocumentFragment();
    for (let side = 0; side < 2; side++) {
      for (let k = 0; k < N; k++) {
        const t1 = -Math.PI / 2 + k * d, t2 = t1 + d;
        const x1 = (1 + Math.sin(t1)) / 2, x2 = (1 + Math.sin(t2)) / 2;   // fractions of image width
        const strip = Math.max(x2 - x1, 1e-4);
        const f = half / strip;
        const face = document.createElement("div");
        face.className = "s3d-face";
        const w = half * 100;
        face.style.width = "calc(" + w.toFixed(4) + "% + 1px)";
        face.style.marginLeft = (-w / 2).toFixed(4) + "%";
        face.style.backgroundImage = 'url("' + src + '")';
        const imgW = 100 * f;                  // whole image width once scaled onto this slice, in cqw
        face.style.backgroundSize = imgW.toFixed(4) + "cqw 100%";
        face.style.backgroundPosition = (-x1 * imgW).toFixed(4) + "cqw 0";
        const phi = ((t1 + t2) / 2) * 180 / Math.PI + side * 180;
        face.style.transform = "rotateY(" + phi.toFixed(3) + "deg) translateZ(" + apothem.toFixed(4) + "cqw)";
        frag.appendChild(face);
      }
    }
    cyl.appendChild(frag);
    cyl.dataset.built = "1";
    cyl.parentElement.classList.add("is-built");
  }

  function initSpin(scope) {
    scope.querySelectorAll("[data-spin]").forEach((demo) => {
      if (demo.dataset.spinReady) return;
      demo.dataset.spinReady = "1";
      const chip = demo.querySelector("[data-spin-chip]");
      const cyl = demo.querySelector("[data-cyl]");
      let timer, anim;
      if (cyl && "IntersectionObserver" in window) {
        const io = new IntersectionObserver((es) => { if (es[0].isIntersecting) { buildCylinder(cyl); io.disconnect(); } }, { rootMargin: "300px" });
        io.observe(demo);
      } else if (cyl) buildCylinder(cyl);
      demo.querySelectorAll("[data-spin-dir]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const dir = btn.dataset.spinDir === "l" ? -1 : 1;
          demo.classList.add("touched");
          demo.classList.remove("is-l", "is-r");
          demo.querySelectorAll("[data-spin-dir]").forEach((b) => b.classList.remove("pressed"));
          void demo.offsetWidth;
          demo.classList.add(dir < 0 ? "is-l" : "is-r");
          btn.classList.add("pressed");
          if (cyl) {
            buildCylinder(cyl);
            if (anim) anim.cancel();
            if (cyl.animate) {
              anim = cyl.animate(
                [{ transform: "translateZ(-50cqw) rotateY(0deg)" }, { transform: "translateZ(-50cqw) rotateY(" + dir * 1080 + "deg)" }],
                { duration: 4200, easing: "cubic-bezier(.4,.05,.25,1)" }
              );
            }
          }
          if (chip) {
            chip.textContent = dir < 0 ? "↺ Spinning left" : "↻ Spinning right";
            chip.classList.add("show");
          }
          clearTimeout(timer);
          timer = setTimeout(() => {
            demo.classList.remove("is-l", "is-r");
            btn.classList.remove("pressed");
            if (chip) chip.classList.remove("show");
          }, 4300);
        });
      });
    });
  }

  /* ---------- "It tells you when": countdown, then waves + beep ---------- */
  // Browsers only allow sound after the visitor has interacted with the page,
  // so the beep is unlocked by the first tap anywhere (or the "Tap to hear" button).
  const Beep = {
    ctx: null,
    unlocked: false,
    unlock() {
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        if (!this.ctx) this.ctx = new AC();
        if (this.ctx.state === "suspended") this.ctx.resume();
        this.unlocked = true;
        document.querySelectorAll("[data-beep-play]").forEach((b) => b.classList.add("unlocked"));
      } catch (e) {}
    },
    play() {
      if (!this.unlocked || !this.ctx || this.ctx.state !== "running") return;
      const ctx = this.ctx, now = ctx.currentTime;
      [0, 0.22].forEach((offset) => {             // "Di~ Di~"
        const osc = ctx.createOscillator(), gain = ctx.createGain();
        osc.type = "sine";
        osc.frequency.setValueAtTime(1760, now + offset);
        osc.frequency.exponentialRampToValueAtTime(1660, now + offset + 0.16);
        gain.gain.setValueAtTime(0.0001, now + offset);
        gain.gain.exponentialRampToValueAtTime(0.18, now + offset + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.17);
        osc.connect(gain).connect(ctx.destination);
        osc.start(now + offset);
        osc.stop(now + offset + 0.2);
      });
    },
  };
  ["pointerdown", "keydown", "touchend"].forEach((ev) =>
    document.addEventListener(ev, () => { if (!Beep.unlocked) Beep.unlock(); }, { passive: true })
  );

  function initBeep(scope) {
    scope.querySelectorAll("[data-beep]").forEach((demo) => {
      if (demo.dataset.beepReady) return;
      demo.dataset.beepReady = "1";
      const secs = Math.max(1, parseInt(demo.dataset.seconds, 10) || 6);
      const sound = demo.dataset.sound !== "false";
      const timer = demo.querySelector("[data-beep-timer]");
      const playBtn = demo.querySelector("[data-beep-play]");
      timer.innerHTML = '<svg class="ring" viewBox="0 0 24 24"><circle class="bg" cx="12" cy="12" r="10"/><circle class="fg" cx="12" cy="12" r="10" pathLength="100"/></svg><span></span>';
      const label = timer.querySelector("span");
      const fg = timer.querySelector(".fg");
      let raf = 0, start = 0, running = false, endTimer;

      function ring() {
        demo.classList.remove("is-beeping");
        void demo.offsetWidth;
        demo.classList.add("is-beeping");
        if (sound) { Beep.play(); setTimeout(() => Beep.play(), 1100); setTimeout(() => Beep.play(), 2200); }
        timer.classList.add("done");
        label.textContent = "Curl ready!";
        fg.style.strokeDashoffset = "0";
        clearTimeout(endTimer);
        endTimer = setTimeout(() => { demo.classList.remove("is-beeping"); timer.classList.remove("show"); }, 3600);
      }
      function tick(now) {
        if (!running) return;
        const elapsed = (now - start) / 1000;
        const left = Math.max(0, secs - elapsed);
        label.textContent = "Curling\u2026 " + Math.ceil(left) + "s";
        fg.style.strokeDashoffset = String(100 - (elapsed / secs) * 100);
        if (left <= 0) { running = false; ring(); return; }
        raf = requestAnimationFrame(tick);
      }
      function begin() {
        if (running) return;
        clearTimeout(endTimer);
        demo.classList.remove("is-beeping");
        timer.classList.remove("done");
        timer.classList.add("show");
        running = true;
        start = performance.now();
        raf = requestAnimationFrame(tick);
      }
      function stop() {
        running = false;
        cancelAnimationFrame(raf);
        timer.classList.remove("show");
      }

      if ("IntersectionObserver" in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.intersectionRatio >= 0.85) begin();
            else if (en.intersectionRatio < 0.5) { stop(); demo.classList.remove("is-beeping"); }
          });
        }, { threshold: [0, 0.5, 0.85, 1] }).observe(demo);
      }
      if (playBtn) {
        playBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          Beep.unlock();
          stop();
          timer.classList.add("show");
          ring();
        });
      }
    });
  }

  /* Looping portrait videos: always muted, no controls, keep playing */
  function initVideos(scope) {
    (scope || document).querySelectorAll(".vid-media video").forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute("controls");
      v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("webkit-playsinline", "");
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) go(); else v.pause(); }); }, { threshold: 0.15 }).observe(v);
      } else go();
      document.addEventListener("touchstart", go, { once: true, passive: true });
    });
  }

  function init(scope) {
    initVideos(scope);
    initMenu(scope);
    initBeep(scope);
    initSpin(scope);
    initReviews(scope);
    initSocialProof(scope);
    scope.querySelectorAll("[data-product]").forEach(initProduct);
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  // theme editor: re-run when a section is re-rendered
  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
